// ============================================================
// DEALIN MVP - Toast Components (wrapper for sonner)
// ============================================================

import { Toaster, toast } from 'sonner';

export const ToastContainer = () => {
  return (
    <Toaster 
      position="top-right"
      toastOptions={{
        className: 'bg-white border border-slate-200 shadow-lg',
        duration: 4000,
      }}
      richColors
      closeButton
    />
  );
};

export const showToast = {
  success: (message: string) => toast.success(message),
  error: (message: string) => toast.error(message),
  info: (message: string) => toast.info(message),
  warning: (message: string) => toast.warning(message),
  loading: (message: string) => toast.loading(message),
  dismiss: (id?: string | number) => toast.dismiss(id),
  promise: <T,>(
    promise: Promise<T>,
    options: {
      loading: string;
      success: string;
      error: string;
    }
  ) => toast.promise(promise, options),
};

export { toast };
export default ToastContainer;

